import React from 'react';
import { Link } from 'react-router-dom';

import SectionImageText from '../components/SectionImageText';

import SectionImageTextBackground from '../assets/images/text-image/image2.jpg';

import '../styles/sites/NoPage.css';

const NoPage = () => {
    return (
        <div className="page__no-page">
            <div className="page__no-page--background">
                <SectionImageText text={`Houston, mamy problem`} wrapperClasses={`container container-small`} backgroundImage={SectionImageTextBackground} />
                <div className="container">
                    <div className="row">
                        <div className="col-12 text-center">
                            <h4>Strona której szukasz niestety nie istnieje</h4>
                            <Link className="btn-general btn-general--primary btn-general--icon-left" to="/">
                                {window.innerWidth < 992 ? 'Strona główna' : 'Wróć na stronę główną'}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoPage;
